<template>

	<div class="landing-contact">


		<section class="content-articles container-fluid" v-in-viewport="" v-if="pageContact.elements">
			<div class="text-center headline-container container">
		  	 	<h1 class="headline" v-in-viewport="">{{pageContact.elements.header_title.value }}</h1>
		 	</div>
		 	<div class="container-fluid">
			 	<div class="row">
			 			<div class="col-sm-12 col-xs-12 col-lg-12 contact-container">
			 					<div class="box-info col-lg-6 col-md-12 col-sm-12 col-xs-12">
				 						<h2>{{pageContact.elements.description.value }}</h2>

				 						<div class="col-sm-6 no-gutters" v-if="pageContactItems">
				 							<div class="contact-item" v-for="citems in pageContactItems" >
				 								<h5 class="item-type"><strong>{{ citems.type.value }}</strong></h5>
				 								<p class="item-name">{{ citems.name.value }}</p>
				 								<p class="item-position">{{ citems.position.value }}</p>
												<p class="item-email"><a :href="'mailto:' + citems.email_address.value">{{ citems.email_address.value }}</a></p>
												<p class="item-phone"> {{ citems.phone_number.value }}</p>
				 							</div>
				 						</div>

				 						<div class="col-sm-6 no-gutters">
				 							<div class="primary-address">
				 								<div v-html="pageContact.elements.agency_address.value"></div>
				 							</div>

											<div id="map" class="map-container"></div>

				 							<div class="google-map-btn">
				 								<button class="btn_orange" v-on:click="openMap">DIRECTIONS</button>
				 							</div>
				 						</div>
			 					</div>

			 					<div class="box-right-img col-lg-6 col-md-6 col-sm-6 col-xs-12 hidden-xs hidden-sm hidden-md" :style="setBackgroundImage(pageContact.elements.image.value[0].url)"></div>
			 			</div>
			 	</div>
			 </div>
		</section>
	</div>
</template>

<script>
	import commons from '../mixins/common.js';
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	require('../assets/img/MT_pin.svg');

	export default{
		name: 'Contact',
		data () {
		   return {
		   		pageContact:[],
		   		pageContactItems: [],
		   }
		},
		created(){
			this.getContact();



		},
		mounted: function() {
			setTimeout(function(){
				var myLatLng = {lat:41.429953, lng:-81.4937603};
				var map = new google.maps.Map(document.getElementById('map'), {
					center: myLatLng,
					zoom: 15,
				});

				var marker = new google.maps.Marker({
					position:myLatLng,
					optimized: false,
					icon: {
				    url: '/dist/MT_pin.svg',
				    scaledSize: new google.maps.Size(32, 32),
					},
					map: map
				});
			},500);

			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);
			
		},
		methods: {
			openMap: function(){
				let urlMap = 'https://www.google.com/maps/place/Marcus+Thomas/@41.430343,-81.494142,15z/data=!4m5!3m4!1s0x0:0x76b5cb3fa0d10d27!8m2!3d41.429716!4d-81.494249?hl=en-419'
				let openTab = window.open(urlMap, '_blank');
				openTab.focus();




			}
		},
		mixins:[apiConnection, commons, seoModule]
	}
</script>



// WEBPACK FOOTER //
// Contact.vue?a38caa1e